<template>
  <div :class="{ 'table-responsive': isResponsive }">
    <div class="row mb10">
      <div class="col-xs-12 col-sm-2 pull-left mt-xs-10">
        <form-group-select
          v-model="totalForPage"
          :options="[
            { text: '10', value: 10 },
            { text: '20', value: 20 },
            { text: '50', value: 50 },
            { text: '100', value: 100 },
            { text: '500', value: 500 },
            { text: '1000', value: 1000 },
            { text: 'Todos', value: rowsLength }
          ]"
          name="totalForPage"
          data-vv-as="Total por página"
          placeholder="Selecione"
          @input="$emit('mudarquantidade', $event)"
        />
      </div>
      <div
        class="col-xs-12 mt-xs-10"
        :class="filtroDatabase ? 'col-sm-8' : 'col-sm-10 pull-right'"
      >
        <form-group-input
          v-model.lazy="filterText"
          name="pesquisa"
          placeholder="Pesquisa"
        />
      </div>
      <div v-if="filtroDatabase" class="col-xs-12 col-sm-2 pull-right mt-xs-10">
        <button-link
          id="btnSearch"
          color="default-alt"
          class="btn-block"
          @click.prevent="$emit('pesquisaritens', filterText)"
        >
          Pesquisar
        </button-link>
      </div>
    </div>
    <table class="table table-striped table-hover" id="tablePerguntas">
      <thead>
        <template>
          <slot name="th"></slot>
        </template>
      </thead>
      <tbody>
        <slot name="rows" :rows="resultsExibe"></slot>
        <tr v-if="!resultsExibe || resultsExibe.length == 0">
          <td colspan="10">Nenhum registro encontrado</td>
        </tr>
      </tbody>
    </table>
    <div class="row">
      <div class="col-md-6 hidden-xs">
        <div class="pull-left mt5 mb10 itens-page">
          Mostrando de {{ start }} até {{ end }} de {{ rowsLength }} registros
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <VuePagination
          class="mt0 pull-right"
          v-model="currentPage"
          :total="totalPages"
          @input="$emit('mudarpagina', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import VuePagination from "vue-bs-pagination";
import Fuse from "fuse.js";

export default {
  name: "data-table",
  components: {
    VuePagination
  },
  props: {
    rows: {
      type: Array,
      default: []
    },
    isResponsive: {
      type: Boolean,
      default: false
    },
    keys: null,
    quantidadeItensTotal: {
      type: Number,
      default: null
    },
    quantidadeItensPagina: {
      type: Number,
      default: null
    },
    pageNumber: {
      type: Number,
      default: null
    },
    textoFiltro: {
      type: String,
      default: null
    },
    filtroDatabase: {
      type: Boolean,
      default: false
    },
    keys: null
  },
  data() {
    return {
      start: 0,
      end: 0,
      totalPages: 1,
      rowsLength: 0,
      resultsExibe: [],
      filterText: this.textoFiltro || "",
      totalForPage: this.pageItens || 20,
      currentPage: this.pageNumber || 1
    };
  },
  asyncComputed: {
    results() {
      if (this.rows) {
        // let newRows = this.removeHtmlresultado(this.rows)
        if (this.filterText != "" && !this.filtroDatabase) {
          return new Promise((resolve, reject) => {
            let run = new Fuse(this.rows, {
              threshold: 0.5,
              keys: this.keys
            });
            let results = run.search(this.filterText);
            resolve(results);
          }).then(response => {
            return response;
          });
        }
        return this.rows;
      }
    }
  },
  methods: {
    removeHtmlresultado(rowsConsulta){
      let rowsLimpas = rowsConsulta.map(function(obj) {
        if (obj && obj.questao && obj.questao.titulo) {
          obj.questao.titulo = obj.questao.titulo.replace(/<\/?[^>]+(>|$)/g, "")
          return obj
        }
      })
      if (rowsLimpas !== undefined){
        return rowsLimpas
      }else{
        return rowsConsulta
      }
    },
    totalPagesFilter(length) {
      let total = Math.ceil(length / parseInt(this.totalForPage)) || 1;
      if (total < this.currentPage) {
        this.currentPage = 1;
      }
      this.totalPages = total;
    },
    alterarPage() {
      this.start = (this.currentPage - 1) * this.totalForPage + 1;
      if (this.rowsLength === 0) {
        this.start = 0;
      }
      this.end = this.currentPage * this.totalForPage;
      if (this.end > this.rowsLength) {
        this.end = this.rowsLength;
      }
      this.resultsExibe = _.slice(this.results, this.start - 1, this.end);
    }
  },
  watch: {
    results(value) {
      this.resultsExibe = value;
      this.rowsLength = !this.quantidadeItensTotal
        ? value && value.length > 0
          ? value.length
          : 0
        : this.quantidadeItensTotal;
      this.totalPagesFilter(this.rowsLength);

      this.alterarPage();
    },
    currentPage(value) {
      this.alterarPage();
    },
    totalForPage() {
      this.currentPage = 1;
      this.totalPagesFilter(this.rowsLength);
      this.alterarPage();
    }
  }
};
</script>

<style>
th {
  cursor: pointer;
}

th button {
  font-size: 9px;
}

.table .ckbox input[type="checkbox"]:checked + label:after {
  top: 3px;
  left: 1px;
}

@media (max-width: 767px) {
  .mt-xs-10 {
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Tables/DataTable.vue